import { gql } from "@apollo/client";

export const exercisesByIdsQuery = gql`
    query GetExercisesByIDs($ids: [Int!]!) {
        exercisesByIds(ids: $ids) {
            id
            nameDe
            nameEn
        }
    }
`;

export interface GetExercisesByIDsQueryType {
    exercisesByIds: Array<{
        id: number;
        nameDe: string;
        nameEn: string;
    }>;
}

export interface GetExercisesByIDsQueryVariables {
    ids: number[];
}
